import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dataLayerPush } from '@/helpers/dataLayer';
import { useIsMobile } from '@/hooks/useIsMobile';
import clsx from 'clsx';
import Button from '../Button/Button';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import toast from 'react-hot-toast';
const ShareButton = ({ icon, label, shareTitle, className, successCopyText, additionalDataLayerProperties = {}, }) => {
    const isMobile = useIsMobile();
    const onShare = async () => {
        dataLayerPush('socialClick', {
            click_url: window.location.href,
            click_text: shareTitle,
            ...additionalDataLayerProperties,
        });
        if (!isMobile) {
            copyUrlToClipboard();
            return;
        }
        try {
            await navigator.share({
                title: shareTitle,
                url: window.location.href,
            });
        }
        catch (error) {
            if (error instanceof Error && error.name !== 'AbortError') {
                copyUrlToClipboard();
            }
        }
    };
    const copyUrlToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            toast.success(successCopyText, {
                duration: 5000,
                position: 'top-center',
                ariaProps: {
                    role: 'alert',
                    'aria-live': 'assertive',
                },
            });
        }
        catch (error) {
            console.error('Failed to copy URL to clipboard:', error);
        }
    };
    return (_jsx(Button, { variant: "outline", mode: "interactive", className: clsx('w-full !py-0.5 sm:w-auto', '!border-ui-specific-glass-light !bg-ui-specific-glass-light-40', 'dark:!text-text-primary', className), children: (buttonProps) => (_jsxs("button", { ...buttonProps, "data-epi-property-name": "shareLabel", onClick: onShare, "data-testid": "share-button", children: [icon && _jsx(ButtonIcon, { variant: icon, className: "h-1.25 w-1.25 text-symbol-hover" }), _jsx("span", { className: "type-button-lg", children: label })] })) }));
};
export default ShareButton;
